import Translate from "../../utils/Translate";

export function getUserMessage(
  tryingToOpenApp,
  loginTypeAttempt,
  bankIdStatus,
  bankIdHintCode,
  eportActionIsSuccessful,
  eportActionErrorMessageTranslationKey,
) {
  let tranlsationKey = "";
  if (bankIdStatus === "pending") {
    if (bankIdHintCode === "outstandingTransaction" || bankIdHintCode === "started") {
      if (tryingToOpenApp) {
        tranlsationKey = "BankIdTryingToStartApp";
      }

      tranlsationKey = "BankIdStartAppThenScanQr";
    }
    if (bankIdHintCode === "userSign") {
      // if(browserType === "desktop") {
      //     return "Skriv din säkerhetskod i BankID-programmet och välj Identifiera"; // todo signera
      // }
      tranlsationKey = "BankIdUserSignIdentify"; // todo signera
    }
  }

  if (bankIdStatus === "failed") {
    switch (bankIdHintCode) {
      case "cancelled":
      case "userCancel":
        tranlsationKey = "BankIdSignCancelled";
        break;

      case "startFailed": {
        tranlsationKey =
          loginTypeAttempt === "qr"
            ? "BankIdQrScanFailed" // This is want bankid states: "BankIdStartFailedQr" but we use our own message
            : "BankIdStartFailed";
        break;
      }

      case "expiredTransaction":
        tranlsationKey = "BankIdExpiredTransaction";
        break;

      case "certificateErr":
        tranlsationKey = "BankIdCertificateError";
        break;

      case "alreadyInProgress":
        tranlsationKey = "BankIdAlreadyInProgress";
        break;

      default:
        tranlsationKey = "BankIdUnspecifiedError";
        break;
    }
  }

  if (bankIdStatus === "complete") {
    // bankId identifiering lyckades

    if (eportActionIsSuccessful === false) {
      // resultat från eport (efter lyckad bankid identifiering) visar misslyckande
      tranlsationKey = eportActionErrorMessageTranslationKey ?? "SomethingFailed";
    }
  }

  return tranlsationKey ? Translate.get(tranlsationKey) : "";
}
